import { render, staticRenderFns } from "./RibbonButton.vue?vue&type=template&id=248f006a&scoped=true&"
import script from "./RibbonButton.vue?vue&type=script&lang=js&"
export * from "./RibbonButton.vue?vue&type=script&lang=js&"
import style0 from "./RibbonButton.vue?vue&type=style&index=0&id=248f006a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f006a",
  null
  
)

export default component.exports